export default {"src":"/_next/static/media/WhoWeAre_046A.991d01c4.JPG","height":690,"width":1920};